<template>
  <div class="ProductdetailApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='2'></headComponent>
    <div class="h"></div>
    <div class="proBg"  :style="'background: url('+baseUrl+setProductDetail.avatar+') no-repeat center;'">
      <div class="proContent">
        <h2>{{setProductDetail.title}}</h2>
        <p>{{setProductDetail.cate}}</p>
      </div>
    </div>
    <div class="proXilie">
      <img class="protrue" :src="baseUrl+setProductDetail.images">
      <div class="right">
        <h2>{{setProductDetail.title}}</h2>
        <p>{{setProductDetail.cate}}</p>
        <p>{{setProductDetail.brief}}</p>
      </div>
    </div>
    <div class="main">
      <div class="title">基础参数</div>
      <div class="con" v-html="setProductDetail.content"></div>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        proBg:require('../../../assets/images/probg.png'),
        setProductDetail:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$fileurl;
    },
    mounted() {
      this.beforeMount();
      this.getProductDetail();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getProductDetail:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/productDetail',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setProductDetail = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .ProductdetailApp .el-message-box{
    width:30%
  }
  .ProductdetailApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .ProductdetailApp .h{
    height:96px
  }
  .ProductdetailApp .proBg{
    height: 39.06vw;
    color:#fff;
    font-size: 18px;
    position: relative;
  }
  .ProductdetailApp .proBg .proContent{
    position: absolute;
    transform: translate(-50%,-50%);
    top:50%;
    left:50%;
    max-width:1200px;
  }
  .ProductdetailApp .proBg h2{
    font-size: 2.4vw;
    padding:0px 0 25px 0;
  }
  .ProductdetailApp .proXilie{
    max-width:1400px;
    margin:0 auto;
    padding:60px 0
  }
  .ProductdetailApp .proXilie:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .ProductdetailApp .proXilie img{
    float:left;
    width:40%
  }
  .ProductdetailApp .proXilie .right{
    float:left;
    width:60%;
  }
  .ProductdetailApp .proXilie .right h2{
    margin-left:50px;
    font-size:40px;
    padding-top:50px
  }
  .ProductdetailApp .proXilie .right p{
    margin-left:50px;
    font-size:18px;
    text-align: justify;
    color:#555;
    padding-top:20px;
    line-height:32px
  }
  .ProductdetailApp .main{
    max-width:1400px;
    margin:0 auto;
    background:#fff;
    font-size:16px;
    color: #333;
    padding: 30px 0
  }
  .ProductdetailApp .main .title{
    text-align:center;
    font-size:22px;
    padding-bottom:25px;
    font-weight:bold
  }
  .ProductdetailApp .main .con{
    width:90%;
    margin:0 auto
  }
  .ProductdetailApp .main p {
    font-size: 16px;
    color: #333;
    letter-spacing: 1px;
    line-height: 24px;
    text-indent: 2em;
    margin-bottom:15px
  }
  .ProductdetailApp .main img {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  
  @media only screen and (max-width: 1199px) {
    .ProductdetailApp .header,.ProductdetailApp .h{
      height:60px;
    }
    .ProductdetailApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .ProductdetailApp .header .nav{
      text-align:right
    }
    .ProductdetailApp .header .nav li{
      margin:0 1.8vw
    }
    .ProductdetailApp .header .nav .close{
      display:none
    }
    .ProductdetailApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .ProductdetailApp .proBg{
      font-size:18px;
    }
    .ProductdetailApp .main dl dd{
      width:50%
    }
    .ProductdetailApp .proXilie{
      padding:20px 0
    }
    .ProductdetailApp .proXilie .right h2{
      font-size:18px;
      margin-left:8px;
      padding-top:8px
    }
    .ProductdetailApp .proXilie .right p{
      font-size:14px;
      margin-left:8px;
      padding-top:8px;
      line-height:22px;
      padding-right:8px
    }
    .ProductdetailApp .main .con{
      width:100%
    }
  } 
</style>